




















































import Vue from 'vue';
import Rs4ComponentBase from '@/shared/application/rs4-component-base';
import Guid from '@/shared/helpers/guid-helper';
import { Prop, Emit, Watch } from "vue-property-decorator";
import { Component } from 'vue-property-decorator';
import { required, maxLength, email } from 'vuelidate/lib/validators';

@Component
export default class EditarConvenio extends Rs4ComponentBase {

     @Prop({ default: false })
     public exibirModal: boolean|undefined;

     @Prop({default: ''})
     public titulo: string|undefined;

     @Prop({default: ''})
     public id: string|undefined;

     @Watch('exibirModal')
     onExibirModal(){
        this.editConvenio(this.IdProp??''); 
     }


    refs = this.$refs as any;
    errors: INameValueDto[] = [];
    loading: boolean = true;
    formTitle: string = '';
    showModal: boolean = false;
    isEdit: boolean = true;
    updated: boolean = false;

    get IdProp() {
        return this.id
    }
    createOrUpdateConvenioInput = {
        grantedRoleIds: [],
        convenio: {} as IConvenioDto
    } as ICreateOrUpdateConvenioInput;

   editConvenio(id: string) {
       debugger;
        this.formTitle = id ? "Editar Convenioss" : "Novo Convênio";
        this.isEdit = id != Guid.empty ? true : false;
        this.errors = [];
        this.rs4Service.get<IGetConvenioForCreateOrUpdateOutput>('/api/convenio/getConvenio?id=' + (id ? id : Guid.empty))
            .then((response) => {
                const result = response.content as IGetConvenioForCreateOrUpdateOutput;
                this.createOrUpdateConvenioInput = {
                    convenio: result.convenio
                };
                if (!this.isEdit)
                {
                    this.refs.form.reset();
                }
                // this.dialog = true;
            });
            this.refs.form.reset();
    }

    save() {
        if (this.refs.form.validate()) {
            this.errors = [];
            this.rs4Service.post<void>('/api/convenio',
                this.createOrUpdateConvenioInput as ICreateOrUpdateConvenioInput)
                .then((response) => {
                    this.updated = true;
                    if (!response.isError) {
                        this.swalToast(2000, 'success', this.$t('Successful').toString());
                        //this.dialog = false;
                    } else {
                        this.errors = response.errors;
                    };
                    this.fecharModal();
                });

        }

    }

    fecharModal(){
        debugger;
        this.$emit("close", "true");
    }
}
